import React, { useState } from "react";
import useMeta from '../../../hooks/useMeta';

import "./Product_OS_UI.css";
import { Product_OS_Data } from "../Product_OS_Data";

import Navbar from "../../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";
import Footer from "../../../CommonComponent/Footer/footer";

import { useParams, Link } from "react-router-dom";

const Product_OS_UI = () => {
    const { ProductOS_PG_ID } = useParams();
    const Current_OS_PG = Product_OS_Data[ProductOS_PG_ID];
    const [slideIndex, setSlideIndex] = useState(0);

    const META_PG_OG_Title = Current_OS_PG?.META_PG_OG_Title || '';
    const META_PG_OG_Description = Current_OS_PG?.META_PG_OG_Description || 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.';
    const META_PG_Canonical_OG_URL = Current_OS_PG?.META_PG_Canonical_OG_URL || '';

    useMeta({
        title: `${META_PG_OG_Title}`,
        description: `${META_PG_OG_Description}`,
        canonical: `${META_PG_Canonical_OG_URL}`,
        og: {
            locale: 'en_US',
            type: 'article',
            title: `${META_PG_OG_Title}`,
            description: `${META_PG_OG_Description}`,
            url: `${META_PG_Canonical_OG_URL}`,
            site_name: 'Callistus Blinds',
        },
    });

    if (!Current_OS_PG) {
        return (
            <>
                <Navbar />
                <NotificationBar />
                <div className="product-os-container">
                    <h1>Error 404: Page Not Found</h1>
                </div>
                <Footer />
            </>
        );
    }

    const {
        Product_OS_TITLE,
        Product_OS_VID_Embed_Link,
        Product_OS_Sub_TITLE,
        Product_OS_DECRIPTION,
        Product_OS_Label,
        Product_OS_Images,
    } = Current_OS_PG;

    const images = Product_OS_Images || [];
    const showSlider = images.length > 0;
    const isSimplePage = showSlider && !Product_OS_Sub_TITLE;

    const goPrev = () => setSlideIndex((i) => (i === 0 ? images.length - 1 : i - 1));
    const goNext = () => setSlideIndex((i) => (i === images.length - 1 ? 0 : i + 1));

    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="product-os-container">
                <nav className="product-os-breadcrumb">
                    <Link to="/">Home</Link>
                    <span className="product-os-breadcrumb-sep">&gt;</span>
                    <span>{Product_OS_TITLE}</span>
                </nav>

                {!isSimplePage && Product_OS_TITLE && (
                    <h2 className="product-os-title">{Product_OS_TITLE}</h2>
                )}

                {Product_OS_Label && (
                    <div className="product-os-label-wrap">
                        <span className="product-os-label">{Product_OS_Label}</span>
                    </div>
                )}

                {showSlider && (
                    <div className="product-os-slider-wrapper">
                        <button className="product-os-slider-arrow left" onClick={goPrev} aria-label="Previous image">&#10094;</button>
                        <img src={images[slideIndex]} alt={Product_OS_TITLE} className="product-os-slider-image" />
                        <button className="product-os-slider-arrow right" onClick={goNext} aria-label="Next image">&#10095;</button>
                    </div>
                )}

                {Product_OS_VID_Embed_Link && (
                    <div className="product-os-video-wrapper">
                        <iframe
                            src={Product_OS_VID_Embed_Link}
                            title={Product_OS_TITLE}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                )}

                {isSimplePage ? (
                    <div className="product-os-simple-details">
                        {Product_OS_TITLE && (
                            <h2 className="product-os-simple-title">{Product_OS_TITLE}</h2>
                        )}
                        {Product_OS_DECRIPTION && (
                            <p className="product-os-simple-description">{Product_OS_DECRIPTION}</p>
                        )}
                    </div>
                ) : (
                    (Product_OS_Sub_TITLE || Product_OS_DECRIPTION) && (
                        <div className="product-os-details">
                            <p className="product-os-overview">Overview</p>
                            {Product_OS_Sub_TITLE && (
                                <h3 className="product-os-feature-title">{Product_OS_Sub_TITLE}</h3>
                            )}
                            {Product_OS_DECRIPTION && (
                                <p className="product-os-description">{Product_OS_DECRIPTION}</p>
                            )}
                            <Link to="/operating-systems" className="product-os-btn">
                                FIND OUT MORE
                            </Link>
                        </div>
                    )
                )}
            </div>
            <Footer />
        </>
    );
};

export default Product_OS_UI;